// Vite's pre-bundle wraps graphql-tag in a lazy __esm initializer (init_lib)
// that sets up the module-level docCache Map. init_lib only runs when the
// Apollo react-hooks chunk is loaded (its top-level body calls init_core
// → init_lib). Several libraries we depend on — notably
// @bottlebooks/gatsby-design-system's Image component — call `gql\`...\``
// at module load. If their chunk evaluates before any Apollo hook chunk
// has triggered init_lib, parseDocument crashes reading `.has` on an
// undefined docCache. This side-effect import forces the Apollo chunks to
// load first, deterministically initialising the cache.
import '@apollo/client';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
